import React from 'react';
import PropTypes from 'prop-types';
import { buildSearchQuery } from '../helpers';
import LinkHandler from '../../link-handler';
import LinkBox from '../../link-box';
import { useSiteConfig } from '../../../hooks/site-config';
import { TipsList } from '../styles';
import CTA from '../../cta';

const NoResults = ({ section, spellingSuggestion }) => {
  const { noResultsFoundLinks, noResultsFoundCta } = useSiteConfig();

  const query = buildSearchQuery({
    query: spellingSuggestion,
    section,
  });

  return (
    <>
      {spellingSuggestion ? (
        <p>
          Did you mean:{' '}
          <LinkHandler link={{ path: query, internal: true }}>
            {spellingSuggestion}
          </LinkHandler>
        </p>
      ) : null}

      <h3>Search tips</h3>

      <TipsList>
        <li>check your spelling </li>
        <li>try fewer words</li>
        <li>try different words that mean the same thing</li>
      </TipsList>

      {noResultsFoundLinks?.links?.length ? (
        <LinkBox {...noResultsFoundLinks} headingLevel={3} />
      ) : null}

      {noResultsFoundCta?.ctaColor ? (
        <CTA
          bg={noResultsFoundCta.ctaColor}
          link={{
            path: noResultsFoundCta.link[0].navigation.path,
            internal: true,
          }}
        >
          See all housing advice
        </CTA>
      ) : null}
    </>
  );
};

NoResults.propTypes = {
  spellingSuggestion: PropTypes.string,
  section: PropTypes.string,
};

export default NoResults;
